export { DATA_PORTAL_ATTRIBUTE, setPortalAttribute } from '@fluentui/dom-utilities';
//# sourceMappingURL=setPortalAttribute.js.map